/* eslint-disable import/prefer-default-export */
export const BUSINESS_DASHBOARD_ENV = {
  dev: "business.lmg-dev.ca",
  stage: "business.lmg-stage.ca",
  prod: "business.getintheloop.ca",
};
